import PanelInlineContent from "../../lib/panel/panel-inline-content";
import { ToggleGroup, ToggleGroupItem } from "@babackapp/ui/components/toggle-group";
import { Smartphone } from "lucide-react";
import { useBlockPanelPropsContext } from "../../lib/panel/panel-container";
import { RowBlockProps } from "./types";
import { useTranslation } from "react-i18next";


export default function PanelRowStackOnMobile() {
  const { t } = useTranslation("editor-blocks-library");
  const blockProps = useBlockPanelPropsContext<RowBlockProps>();
  const value = blockProps.block.properties?.stackOnMobile !== false ? "on" : "off";

  const handleUpdate = (enabled: boolean) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      properties: {
        ...blockProps.block.properties,
        stackOnMobile: enabled,
      },
    });
  };

  return (
    <PanelInlineContent title={t("editorBlocksLibrary.blocks.row.panel.stackOnMobile.title", "Stack on mobile")}>
      <ToggleGroup
        variant="default"
        type="single"
        className="bg-background border shadow"
        value={value}
        onValueChange={(value) => {
          if (value === "on" || value === "off") {
            handleUpdate(value === "on");
          }
        }}
      >
        <ToggleGroupItem value="on" aria-label="Stack on mobile">
          <Smartphone className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem value="off" aria-label="No stacking">
          <span className="text-xs font-medium">{t("editorBlocksLibrary.blocks.row.panel.stackOnMobile.off", "Off")}</span>
        </ToggleGroupItem>
      </ToggleGroup>
    </PanelInlineContent>
  );
}
